module.exports = __webpack_public_path__ + "static/media/hairdresser.e3268937.png";